import {useMutation, useQuery} from "@tanstack/react-query";
import {CaseLegalRemedyModel} from "app/edozvola/cases/cases.model";
import {showToast} from "app/shared/util/toast.util";
import {ERRORS, messages} from "app/config/constants";
import {queryClient} from "app/app";
import {toast} from "react-toastify";
import success = toast.success;
import {fetchCaseLegalRemedy, saveCaseLegalRemedy} from "app/edozvola/cases/service/cases.service";


export const saveCaseLegalRemedyMutation = (idCase: string) => {
  return useMutation({
    mutationFn: (values: CaseLegalRemedyModel) => {
      return saveCaseLegalRemedy(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['case-legal-remedy'] });
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};




export const fetchCaseLegalRemedyQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-legal-remedy'],
    queryFn: () => fetchCaseLegalRemedy(idCase)
  });
};
